import { Switch } from '@ipfabric/ui-components/Switch/Switch';
import type { TableColumnConfig } from '@ipfabric/utils';
import { is } from '@ipfabric/utils/fp/comparison';
import { execWithArgs } from '@ipfabric/utils/fp/function';
import { prop } from '@ipfabric/utils/fp/prop';
import { makeIsColumnVisible } from 'components/Table/helpers/makeIsColumnVisible';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { changeTableColumnVisibility } from 'components/Table/model/commands/changeTableColumnVisibility';
import { selectVisibleColumns } from 'components/Table/model/selectors/selectVisibleColumns';
import { flow } from 'fp-ts/function';
import type { FC } from 'react';

interface Props {
  column: TableColumnConfig;
}

export const TableSettingsColumnVisibilityToggle: FC<Props> = (props) => {
  const ctxProps = useTableContextSelectors({
    visible: flow(
      prop('settings', 'columnVisibility'),
      makeIsColumnVisible,
      execWithArgs(props.column),
    ),
    onlyOneVisible: flow(selectVisibleColumns, prop('length'), is(1)),
    dispatch: prop('dispatch'),
  });

  return (
    <Switch
      dataTestId={`column-visibility-toggle-${props.column.key}`}
      disabled={ctxProps.visible && ctxProps.onlyOneVisible}
      onChange={() => {
        ctxProps.dispatch(changeTableColumnVisibility, {
          columnKey: props.column.key,
          value: !ctxProps.visible,
        });
      }}
      value={ctxProps.visible}
    />
  );
};
